import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as rootState,
} from '../../utils/redux';

const requestOptions = {
  endpoint: 'complaint_notifications',
  type: 'get',
  slug: [
    {
      type: 'payload.query',
      queryParameter: 'status',
      selector: 'status',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
};

export const consts = createReqConsts('complaints', 'resolved-list', [
  'LOAD_MORE',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions);

export const paginationConsts = createReqConsts(
  'complaints',
  'resolved-list-lazy-load',
);
export const paginationActions = createActions(paginationConsts);
export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
);

const initialState = {
  ...rootState,
  pagination: { offset: 0, limit: 10 },
};

const defaultRequestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  switch (action.type) {
    case consts.SEND: {
      return {
        ...state,
        ...rootState,
        sending: !action.payload.silent,
      };
    }

    case consts.SUCCEED: {
      return {
        ...state,
        ...rootState,
        succeed: true,
        list: action.payload,
      };
    }

    case paginationConsts.SUCCEED: {
      return {
        ...state,
        list: [...state.list, ...action.payload],
      };
    }
    default:
      return defaultRequestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/complaints/complaintResolvedList.js